import React from 'react';

import { Alert, Box, Typography } from '@mui/material';

import { ITEM_STATUS_COMPLETED } from '~/consts/order';

interface Props {
  experiences?: ReadonlyArray<App.ExperienceItem>;
}

export default function ExperienceRefundWarning({ experiences = [] }: Props) {
  const activeExperiences = experiences.filter((experience) => experience.status === ITEM_STATUS_COMPLETED);

  return (
    <Alert severity="warning">
      <Typography variant="body2" fontWeight="bold">
        {activeExperiences.length > 0
          ? `This order has ${activeExperiences.length} active experience${activeExperiences.length === 1 ? '' : 's'}.`
          : 'This order has active experiences.'}
      </Typography>
      {activeExperiences.length > 0 && (
        <Box component="ul" sx={{ my: 1, pl: 2 }}>
          {activeExperiences.map((experience) => {
            const name =
              experience.ticket?.type === 'AIRPORT-TO-HOTEL'
                ? 'Airport pickup'
                : experience.ticket?.type === 'HOTEL-TO-AIRPORT'
                  ? 'Airport drop-off'
                  : experience.title || experience.ticket?.fareType || 'Experience';

            return (
              <Typography component="li" variant="body2" key={experience.id} sx={{ overflowWrap: 'anywhere' }}>
                {name}
                {experience.booking_number && ` · ${experience.booking_number}`}
              </Typography>
            );
          })}
        </Box>
      )}
      <Typography variant="body2">
        Included experiences may be cancelled with their accommodation. Check whether any others need a separate
        cancellation or refund.
      </Typography>
    </Alert>
  );
}
